export var EventTypes;
(function (EventTypes) {
    EventTypes["TEMPERATURE"] = "temperature";
    EventTypes["HUMIDITY"] = "humidity";
    EventTypes["CO2"] = "co2";
    EventTypes["UPTIME"] = "uptime";
    EventTypes["SMARTPLUG_CHANGE"] = "smartplugchange";
    EventTypes["DEWPOINT"] = "dewpoint";
    EventTypes["PRESSURE"] = "pressure";
    EventTypes["ATM_PRESSURE"] = "atmosphericpressure";
    EventTypes["TEMPERATURE_OFFSET"] = "temperaturecorrected";
    EventTypes["HUMIDITY_OFFSET"] = "humiditycorrected";
    EventTypes["WATER_LEVEL"] = "waterlevel";
    EventTypes["FLOOD_DETECTOR"] = "flooddetector";
    EventTypes["WIND_DIRECTION"] = "winddirection";
    EventTypes["WIND_SPEED"] = "windspeed";
    EventTypes["NOISE"] = "noise";
    EventTypes["PM1"] = "pm1";
    EventTypes["PM2P5"] = "pm2p5";
    EventTypes["PM4"] = "pm4";
    EventTypes["PM10"] = "pm10";
    EventTypes["NO"] = "no";
    EventTypes["NO2"] = "no2";
    EventTypes["NOX"] = "noxidx";
    EventTypes["VOC"] = "vocidx";
})(EventTypes || (EventTypes = {}));
export default EventTypes;
export const OWN_EVENTTYPE_ICON = new Set([
    EventTypes.ATM_PRESSURE,
    EventTypes.TEMPERATURE_OFFSET,
    EventTypes.HUMIDITY_OFFSET,
    EventTypes.WATER_LEVEL,
    EventTypes.WIND_DIRECTION,
    EventTypes.WIND_SPEED,
    EventTypes.NOISE,
    EventTypes.PM1,
    EventTypes.PM2P5,
    EventTypes.PM4,
    EventTypes.PM10,
    EventTypes.NO,
    EventTypes.NO2,
    EventTypes.NOX,
    EventTypes.VOC,
    EventTypes.CO2
]);
export const SENSOR_ORDER = new Map([
    // Category 1: Primary LogHub
    [EventTypes.TEMPERATURE, 10],
    [EventTypes.HUMIDITY, 11],
    [EventTypes.DEWPOINT, 12],
    [EventTypes.TEMPERATURE_OFFSET, 13],
    [EventTypes.HUMIDITY_OFFSET, 14],
    [EventTypes.PRESSURE, 15],
    [EventTypes.ATM_PRESSURE, 16],
    // Category 2: Air Quality - Gases
    [EventTypes.CO2, 20],
    [EventTypes.VOC, 21],
    [EventTypes.NOX, 22],
    [EventTypes.NO, 23],
    [EventTypes.NO2, 24],
    // Category 3: Air Quality - Particulates
    [EventTypes.PM1, 30],
    [EventTypes.PM2P5, 31],
    [EventTypes.PM4, 32],
    [EventTypes.PM10, 33],
    // Category 4: Environmental
    [EventTypes.NOISE, 40],
    [EventTypes.WIND_SPEED, 41],
    [EventTypes.WIND_DIRECTION, 42],
    [EventTypes.WATER_LEVEL, 43],
    [EventTypes.FLOOD_DETECTOR, 44],
    // Category 5: System Diagnostics
    [EventTypes.UPTIME, 50],
    [EventTypes.SMARTPLUG_CHANGE, 51]
]);
export var SmartPlugSources;
(function (SmartPlugSources) {
    SmartPlugSources[SmartPlugSources["POWER"] = 1] = "POWER";
    SmartPlugSources[SmartPlugSources["BATTERY"] = 2] = "BATTERY";
    SmartPlugSources[SmartPlugSources["UNKNOWN"] = 0] = "UNKNOWN";
})(SmartPlugSources || (SmartPlugSources = {}));
